import React from "react";
import { useIntl } from "react-intl";
import NoFooterModal from "../NoFooterModal";
import { FavouriteTemplateCardLinkList } from "../../TemplateCardLinkList";
import FlowioErrorBoundary from "../../../atoms/FlowioErrorBoundary";

const FavouriteTemplatesModal = ({
  isOpen,
  toggleOpen,
}: FavouriteTemplatesModalProps) => {
  const { formatMessage } = useIntl();
  const title = formatMessage({ id: "common.favourite_templates" });

  return (
    <NoFooterModal isOpen={isOpen} toggle={toggleOpen} title={title}>
      <FlowioErrorBoundary>
        <FavouriteTemplateCardLinkList onClickSideEffects={toggleOpen} />
      </FlowioErrorBoundary>
    </NoFooterModal>
  );
};

export type FavouriteTemplatesModalProps = {
  isOpen: boolean;
  toggleOpen: () => void;
};

export default FavouriteTemplatesModal;
